import { Controller, useForm } from "react-hook-form";
import useAxios from "../../../../Utils/useAxios";
import { Form, Button } from "reactstrap";
import { CheckboxField, InputField } from "../../../../CommonElements";
import createFooter from "../services/createFooter";
import updateFooter from "../services/updateFooter";

const FooterForm = ({ data, resetState, toggle }) => {
  const { control, handleSubmit } = useForm({
    defaultValues: data || { content: '', is_active: true }
  });
  const axiosInstance = useAxios();

  const onSubmit = async (formData) => {
    try {
      if (data?.id) {
        await updateFooter(axiosInstance, data.id, formData);
      } else {
        await createFooter(axiosInstance, formData);
      }
      resetState();
      toggle();
    } catch (error) {
      console.error('Error saving footer:', error);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="content"
        control={control}
        rules={{ required: "Footer content is required" }}
        render={({ field, fieldState }) => (
          <InputField
            type="textarea"
            label="Footer Content"
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      
      <Controller
        name="is_active"
        control={control}
        render={({ field }) => (
          <CheckboxField
            label="Active"
            {...field}
          />
        )}
      />

      <Button color="primary">Save</Button>
    </Form>
  );
};

export default FooterForm;